import React, {useState, useEffect,useContext} from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { numFormatter, monthsShort, getTokenAndUid } from '../../../lib/utils'
import { get } from '../../../lib/api'
import { Text, Box } from '../../../designSystem'
import { AccountContext } from '../../../providers/accountProvider';
import { dummy_entity_id_for_all_book } from './constants'
import { useInfiniteScroll } from '../../../lib/customHooks'
import Loader from '../../../components/Loader'
dayjs.extend(customParseFormat)

const CardDiv = styled.div`
  background: linear-gradient( to right,  var(--Text500), #F8F9FE );
  -webkit-text-fill-color: transparent; 
  -webkit-background-clip: text;
  background-clip: text;
`

const ApplicationHistory = ({ onViewMoreClick, bookSelected}) => {
  const [feedArr, setFeedArr] = useState([])
  const [isLoading,setIsLoading] = useState(true)
  const [nextUrl, setNextUrl] = useState(null)
  const {user,onUpdateUser} = useContext(AccountContext)
  useEffect(() => {
    fetchFeedArr()
  }, [bookSelected])

  const getMileStoneText = entity => {
    const words = numFormatter(entity.reward_details.props.word_limit)
    const baseText = words + " Milestone Award"
    if (entity.action === 'approved') return baseText + " - Added To Wallet"
    return baseText
  }
  
  const getProgramText = entity => {
    const baseText = "Writer Benefit Program " + " - "
    if (entity.action === 'pending') return baseText + "Pending Approval"
    if (entity.action === 'rejected') return baseText + "Rejected"
    if (entity.action === 'ongoing') return baseText + "Accepted"
    if (entity.action === 'updated') return baseText + "Updated"
    if (entity.action === 'approved') return baseText + "Approved"
    return baseText
  }
  const getWalletText = entity => {
    const amount = entity.txn_data.amount
    const baseText = ((user?.login_type!=="email_login") || (user?.login_type==="email_login" && user?.location==='IN') ?"Rs":"$") + amount + " Withdrawal Request - "
    if (entity.action === 'pending') return baseText + "Under Review"
    if (entity.action === 'rejected') return baseText + "Rejected"
    if (entity.action === 'accepted') return baseText + "Accepted"
    if (entity.action === 'approved') return baseText + "Approved"
    return baseText
  }
  const getRewardText = entity => {
    let monthYear = ''
    const date = new Date(entity.reward_details.props.end_date)
    const year = date.getFullYear()
    const month = monthsShort[date.getMonth()]
    monthYear = month + ' ' + year
    const baseText = `Monthly reward for ${monthYear} - `
    if (entity.action === 'pending') return baseText + "Pending Approval"
    if (entity.action === 'accepted') return baseText + "Accepted"
    if (entity.action === 'approved') return baseText + "Added to Wallet"
    if (entity.action === 'rejected') return baseText + "Rejected"
    return baseText
  }
  
  const getTextFromFeedEntity = entity => {
    switch (entity.action_on) {
      case "program": {
        return getProgramText(entity)
      }
      case "reward": {
        if (entity.reward_details.reward_type === 'milestone') return getMileStoneText(entity)
        return getRewardText(entity)
      }
      case "wallet": {
        return getWalletText(entity)
      }
      default:
        return ""
    }
  }
  const fetchFeedArr = () => {
    const { uid } = getTokenAndUid()
    setIsLoading(true)
    get(`/content_api/book.user_application/${uid}/?is_novel=1`).then(response => {
      setIsLoading(false)
      const { result, next_url } = response
      if(bookSelected === dummy_entity_id_for_all_book){
          setFeedArr(result)
          setNextUrl(next_url)
          return;
      }
      setFeedArr(result.filter(history => history.book_details.book_id === bookSelected))
      setNextUrl(next_url)
    })
  }

  const fetchMoreFeedArr = (setIsFetching) => {
    if(!nextUrl){
      setIsFetching(false)
      return
    }
    get(nextUrl).then(response => {
      const { result, next_url } = response
      setIsFetching(false)
      if(bookSelected === dummy_entity_id_for_all_book){
          setFeedArr((prevFeedArr) => prevFeedArr.concat(result))
          setNextUrl(next_url)
          return;
      }
      setFeedArr((prevFeedArr) => prevFeedArr.concat(result.filter(history => history.book_details.book_id === bookSelected)))
      setNextUrl(next_url)
    })
  }

  // const isFetching = useInfiniteScroll(fetchMoreFeedArr)

  if(isLoading) return <Loader />

  return (
    <React.Fragment>
      {
        feedArr.map(entity => {
          return (
          <Box variant="flex" flexDirection="column" bg='surface.foreground' px={18} py={16} my={4} key={entity.id}  >
              <Text variant="title" fontWeight="r">{getTextFromFeedEntity(entity)} </Text>
            <CardDiv>
              <Text variant="subtext">{entity?.book_details?.book_title }</Text>
            </CardDiv>
              <Text variant="subtext">{dayjs(entity.create_time).format('DD MMM YYYY')}</Text>
          </Box>
          )
        })
      }
      {/* {isFetching && <Loader />} */}
    </React.Fragment>
  )
}

export default ApplicationHistory
